import React from 'react';

const TermsAndConditions = () => {
  const sectionStyle = { marginBottom: '25px' };
  const headingStyle = { color: '#1a73e8', borderBottom: '1px solid #eee', paddingBottom: '5px', marginTop: '25px' };
  const textStyle = { color: '#555', fontSize: '15px', lineHeight: '1.7' };

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto', backgroundColor: '#fff', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center' }}>AI News – Terms & Conditions</h1>
      <p style={{ textAlign: 'center', color: '#777', fontWeight: 'bold' }}>
        Last updated: January 2026
      </p>

      <section style={sectionStyle}>
        <p style={textStyle}>
          These Terms & Conditions govern your access to and use of the AI News mobile application and related services,
          operated by <strong>PRAGATHI PUBLICATIONS</strong> (“we”, “us”, “our”).
        </p>
        <p style={textStyle}>
          By accessing or using AI News, you agree to be bound by these Terms. If you do not agree, please discontinue use of the app.
        </p>
      </section>

      <h2 style={headingStyle}>1. Definations</h2>
      <div style={textStyle}>
        <p><strong>App:</strong> AI News mobile application.</p>
        <p><strong>User:</strong> Any person who accesses or uses the App.</p>
        <p><strong>Content:</strong> News, jobs, advertisements, images, videos, text, or user submissions.</p>
        <p><strong>Third-Party Services:</strong> APIs, websites, or platforms not owned by AI News.</p>
      </div>

      <h2 style={headingStyle}>2. Nature of the Platform</h2>
      <div style={textStyle}>
        <p><strong>Ai News is a news aggregation and user-generated content platform that displays:</strong></p>
        <ul style={textStyle}>
        <li>User-posted news, jobs, and advertisements</li>
        <li>Aggregated news from third-party APIs</li>
        <li>Local information such as weather, IPL scores, and stock market data</li>
      </ul>
      <p>Ai News acts as an intermediary and does not claim ownership of third-party or user-generated content.</p>
      </div>

      <h2 style={headingStyle}>3. Nature of Service</h2>
      <p style={textStyle}>
        AI News is a digital news aggregation and user-generated content platform. We display publicly available news,
        job updates, advertisements, and user-submitted content. AI News acts as an <strong>intermediary</strong>
        under applicable Indian laws.
      </p>

      <h2 style={headingStyle}>4. User Accounts & Authentication</h2>
      <ul style={textStyle}>
        <li>Users must sign up or log in using email ID, mobile number, and password to post content.</li>
        <li><strong>After login, users can access their profile, where they can:</strong></li>
        <ul style={textStyle}>
          <li>View their posted news, jobs, and ads</li>
          <li>Edit or delete their own content</li>
        </ul>
        <li>Users are responsible for maintaining the confidentiality of their login credentials.</li>
      </ul>

      <h2 style={headingStyle}>5. User Responsibilities</h2>
      <ul style={textStyle}>
        <li>You must not post false, misleading, defamatory, obscene, hateful, or illegal content.</li>
        <li>You must not impersonate any individual or organization.</li>
        <li>You are solely responsible for the content you submit.</li>
        <li>Violation of laws may result in account suspension or legal action.</li>
      </ul>

      <h2 style={headingStyle}>6. User-Generated News Posting Policy</h2>
      <h3 style={headingStyle}>6.1 News Categories</h3>
      <p style={textStyle}><strong>
        Users can post news under categories such as:
        </strong></p>
        <ul style={textStyle}>
        <li>India</li>
        <li>State</li>
        <li>Special Days (only when applicable)</li>
      </ul>
      <p style={textStyle}><strong>
        Approved posts may appear in:
        </strong></p>
        <ul style={textStyle}>
        <li>All News</li>
        <li>Local News</li>
        <li>View All sections</li>
        <li>Special Days page</li>
      </ul>

      <h3 style={headingStyle}>6.2 News Posting Guidelines</h3>
      <p style={textStyle}><strong>
        Title
        </strong></p>
        <ul style={textStyle}>
        <li>Minimum 20 characters</li>
        <li>Must be clear, relevant, and properly punctuated</li>
        <li>Misleading or clickbait titles are prohibited</li>
      </ul>
      <p style={textStyle}><strong>
        Content
        </strong></p>
        <ul style={textStyle}>
        <li>Minimum 50 words, maximum 60 words</li>
        <li>Must be factual, accurate, and up-to-date</li>
        <li>Fake, outdated, or misleading news will be rejected</li>
        <li>Obscene, vulgar, hateful, religiously provocative, criminal, or sensitive content is strictly prohibited</li>
        <li>Content must be original and not copied from any source</li>
      </ul>
      <p style={textStyle}><strong>
        Article Quality
        </strong></p>
        <ul style={textStyle}>
        <li>Must answer What, Why, Where, Who, When, and How</li>
        <li>No biased or plagiarized content</li>
        <li>Clear language and error-free writing</li>
      </ul>
      <p style={textStyle}><strong>
        Images
        </strong></p>
        <ul style={textStyle}>
        <li>Up to 3 images</li>
        <li>Horizontal / rectangle / square formats only</li>
        <li>Images must be clear and relevant</li>
        <li>Obscene or sensitive images are strictly prohibited</li>
      </ul>

      <h2 style={headingStyle}>7. AI News Assistant Feature</h2>
        <ul style={textStyle}>
        <li>The app provides an AI News Assistant to help users create news content in Telugu.</li>
        <li><strong>If a user provides basic details of an event or topic, the AI can:</strong></li>
        <ul>
          <li>Generate a clear Telugu news title</li>
          <li>Provide a full news description</li>
        </ul>
        <li><strong>This feature is intended to assist users who:</strong></li>
        <ul>
          <li>Are unsure how to write news professionally</li>
          <li>Need help framing content in proper Telugu</li>
        </ul>
        <li>Users are responsible for reviewing AI-generated content before posting.</li>
      </ul>

      <h2 style={headingStyle}>8. AI-Based Content Moderation</h2>
      <ul style={textStyle}>
        <li>All user-posted news is reviewed using AI technologies</li>
        <li><strong>Content may be rejected automatically if:</strong></li>
        <ul style={textStyle}>
          <li>It is duplicated</li>
          <li>Contains abusive or inappropriate Telugu words</li>
          <li>Violates platform policies</li>
        </ul>
        <li>Final moderation decisions remain with Ai News</li>
      </ul>

      <h2 style={headingStyle}>9. Job Posting Policy</h2>
      <ul style={textStyle}>
        <li>Users can post jobs only after login</li>
        <li>Jobs can be searched by location</li>
        <li><strong>Job visibility rules:</strong></li>
        <ul style={textStyle}>
          <li><strong>Private jobs:</strong> active for 30 days</li>
          <li><strong>Government jobs:</strong> removed after the last application date</li>
        </ul>
        <li>After expiry, reposting may require payment</li>
        <li>Users can edit/delete their posted jobs from their profile</li>
      </ul>

      <h2 style={headingStyle}>10. Advertisements & Promotions</h2>
      <ul style={textStyle}>
        <li>Users can post advertisements by paying a promotional fee</li>
        <li><strong>Advertisement requirements:</strong></li>
        <ul style={textStyle}>
          <li>Brand/Sponsor name</li>
          <li>Website link (optional)</li>
          <li>Business image (dark background preferred for readability)</li>
        </ul>
        <li>Vulgar, sexual, or illegal advertisements are strictly prohibited</li>
        <li>Paid promotions are non-refundable</li>
        <li>Ads expire after one month</li>
        <li>Ads can be edited within the active period</li>
        <li>Ai News reserves the right to remove or block ads violating policy</li>
      </ul>
      <p>The App may display advertisements and sponsored content clearly labeled as “Ad” or “Sponsored”.
        AI News does not endorse advertised products or services.</p>

      <h2 style={headingStyle}>11. Payments</h2>
      <div style={textStyle}>
        <ul style={textStyle}>
        <li>Online payments are processed securely via Razorpay</li>
        <li>Ai News does not store card or UPI credentials</li>
        <li>All transactions are final unless required by law</li>
      </ul>
      </div>

      <h2 style={headingStyle}>12. Reporting & Abuse Management</h2>
      <ul style={textStyle}>
        <li>Users can report news as fake, spam, or misleading</li>
        <li>Reported content is reviewed by admin</li>
        <li><strong>Admin may:</strong></li>
        <ul style={textStyle}>
          <li>Delete content</li>
          <li>Block users</li>
          <li>Take legal action if required</li>
        </ul>
      </ul>

      <h2 style={headingStyle}>13. Third-Party Content & Sources</h2>
      <p style={textStyle}>
        AI News displays content sourced from third-party providers such as news APIs, publishers, and public sources.
        We do not exercise editorial control over third-party content and are not responsible for its accuracy.
      </p>
      <p>Ai News uses third-party services for data display. We do not control or guarantee their accuracy.</p>
      <p><strong>Third-Party Services Used:</strong></p>
      <ul style={textStyle}>
        <li><strong>News APIs:</strong>NewsData.io, GNews</li>
        <li><strong>Location Services:</strong>Google Maps Platform APIs</li>
        <li><strong>Weather Data:</strong>OpenWeatherMap</li>
        <li><strong>Cricket Scores:</strong>CricketData.io</li>
        <li><strong>Stock Market Data:</strong>Yahoo Finance</li>
        <li><strong>Payments:</strong>Razorpay</li>
        <li><strong>AI & NLP Services:</strong>Google AI APIs</li>
        </ul>
        <p>Users are encouraged to verify critical information from original sources.</p>

      <h2 style={headingStyle}>14. Disclaimer of Liability</h2>
      <ul style={textStyle}>
        <li>Ai News is not responsible for the accuracy of user-generated or third-party content</li>
        <li>Users rely on content at their own risk</li>
        <li>We are not liable for losses arising from news, jobs, ads, weather, stocks, or sports data</li>
        </ul>

      <h2 style={headingStyle}>15. Account Suspension & Termination</h2>
      <p><strong>We reserve the right to:</strong></p>
      <ul style={textStyle}>
        <li>Suspend or terminate accounts violating these Terms</li>
        <li>Remove any content without prior notice</li>
        </ul>

      <h2 style={headingStyle}>16. Intellectual Property</h2>
      <p style={textStyle}>
        All app design, logos, and original content belong to PRAGATHI PUBLICATIONS.
        Third-party content remains the property of its respective owners.
      </p>

      <h2 style={headingStyle}>17. Disclaimer</h2>
      <p style={textStyle}>
        All content is provided on an “as-is” basis. AI News does not guarantee accuracy, completeness, or reliability.
        Users should verify information from official sources before acting on it.
      </p>

      <h2 style={headingStyle}>18. Limitation of Liability</h2>
      <p style={textStyle}>
        AI News shall not be liable for any direct, indirect, incidental, or consequential damages arising
        from use of the App or reliance on its content.
      </p>

      <h2 style={headingStyle}>19. Changes to Terms</h2>
      <p style={textStyle}>
        These Terms may be updated at any time. Continued use of the App indicates acceptance of revised Terms.
      </p>

      <h2 style={headingStyle}>20. Governing Law</h2>
      <p style={textStyle}>
        These Terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction
        of courts located in Andhra Pradesh, India.
      </p>

      <h2 style={headingStyle}>21. Contact Information</h2>
      <div style={textStyle}>
        <p><strong>Email:</strong> ainewstelugu@zohomail.in</p>
        <p><strong>Publisher:</strong> PRAGATHI PUBLICATIONS</p>
        <p><strong>Location:</strong> Kurnool, Andhra Pradesh, India</p>
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px', fontSize: '12px', color: '#aaa' }}>
        © AI News – Owned & Operated by PRAGATHI PUBLICATIONS
      </div>
    </div>
  );
};

export default TermsAndConditions;
